/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$('body').on('click', 'ol.slideshow__indicators a', function(e) {
	e.preventDefault();
  	var slide_index = $(this).data("slide-index");
  	$("ol.slideshow__indicators a").removeClass("slideshow__indicator--active");
  	$(this).addClass("slideshow__indicator--active");
  	$(".slideshow__slide").removeClass("slideshow__slide--active");
  	$("li#Slide"+slide_index).addClass("slideshow__slide--active");
  	
});
